<template>
  <div>
    <h1>Post Logout</h1>
  </div>
</template>
